import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';
import PhoneSupport from '../PhoneSupport/PhoneSupport';

const HASH_NAV = [
	{ label: 'Videó', id: 'video' },
	{ label: 'Szolgáltatás', id: 'szolgaltatas' },
	{ label: 'Csapat', id: 'csapat' },
	{ label: 'Vélemények', id: 'velemenyek' },
];

const PAGE_NAV = [
	{ label: 'Árlista', to: '/arlista' },
	{ label: 'Blog', to: '/blog' },
];

export default function Header() {
	const [menuOpen, setMenuOpen] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	function scrollToSection(id: string) {
		setMenuOpen(false);
		if (location.pathname === '/') {
			document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
		} else {
			navigate('/');
			window.setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 120);
		}
	}

	return (
		<header className="menubar">
			<div className="menubar__inner">
				<Link to="/" className="menubar__logo" aria-label="Akku 24+ főoldal">
					<img src={logo} alt="Akku 24+" />
				</Link>

				<PhoneSupport className="phonebtn--header" />

				<nav className="menubar__nav">
					{HASH_NAV.map((item) => (
						<a key={item.id} href={`/#${item.id}`} onClick={(e) => { e.preventDefault(); scrollToSection(item.id); }}>
							{item.label}
						</a>
					))}
					{PAGE_NAV.map((item) => (
						<Link
							key={item.to}
							to={item.to}
							className={location.pathname.startsWith(item.to) ? 'is-active' : undefined}
						>
							{item.label}
						</Link>
					))}
				</nav>

				<button
					type="button"
					className="menubar__burger"
					aria-label="Menü"
					onClick={() => setMenuOpen(true)}
				>
					<span /><span /><span />
				</button>
			</div>

			<div className={`mobilemenu ${menuOpen ? 'is-open' : ''}`}>
				<button type="button" className="mobilemenu__close" aria-label="Bezárás" onClick={() => setMenuOpen(false)}>×</button>
				{HASH_NAV.map((item) => (
					<a key={item.id} href={`/#${item.id}`} onClick={(e) => { e.preventDefault(); scrollToSection(item.id); }}>
						{item.label}
					</a>
				))}
				{PAGE_NAV.map((item) => (
					<Link key={item.to} to={item.to} onClick={() => setMenuOpen(false)}>{item.label}</Link>
				))}
				<a href="https://www.facebook.com/akku24" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)}>Facebook</a>
			</div>
		</header>
	);
}
